import HomeHero from "./components/HomeHero";
import HomeTagline from "./components/HomeTagline";
import HomeHighlights from "./components/HomeHighlights";
import HomePopularFlavors from "./components/HomePopularFlavors";
import HomeDelivery from "./components/HomeDelivery";
import HomeFranchise from "./components/HomeFranchise";
import HomeNews from "./components/HomeNews";
import GlobalBottomCta from "@/components/feature/GlobalBottomCta";
import PageMeta from "@/components/feature/PageMeta";

const pageMeta = {
  title: "首頁｜來加綉綉紅豆餅",
  description: "來加綉綉紅豆餅，嚴選食材、厚實內餡、職人現烤的台灣手作車輪餅品牌。提供冷凍宅配禮盒、人氣口味紅豆餅、加盟創業方案。每一口都是剛出爐的幸福。",
  keywords: "來加綉綉紅豆餅,紅豆餅,車輪餅,台灣紅豆餅,手作紅豆餅,現烤紅豆餅,紅豆餅宅配,冷凍紅豆餅,紅豆餅禮盒,紅豆餅加盟",
  ogType: "website",
};

export default function Home() {
  return (
    <main>
      <PageMeta {...pageMeta} />
      <HomeHero />
      <HomeTagline />
      <HomeHighlights />
      <HomePopularFlavors />
      <HomeDelivery />
      <HomeFranchise />
      <HomeNews />
      <GlobalBottomCta />
    </main>
  );
}